(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["built-with-intention"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBuiltWithIntention(root) {
      if (root.dataset.biInit) return;
      root.dataset.biInit = 'true';

      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-bi-row]'));
      if (!rows.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      root.classList.add('js-ready');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      rows.forEach(function (row) { io.observe(row); });
    }

    document.querySelectorAll('[data-bi-root]').forEach(initBuiltWithIntention);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCategoryCards(root) {
      if (root.dataset.ccInit) return;
      root.dataset.ccInit = 'true';

      var track = root.querySelector('[data-cc-track]');
      var prev = root.querySelector('[data-cc-prev]');
      var next = root.querySelector('[data-cc-next]');
      if (!track) return;

      function cardDelta() {
        var card = track.querySelector('[data-cc-card]');
        if (!card) return 300;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -cardDelta(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: cardDelta(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    document.querySelectorAll('[data-cc-root]').forEach(initCategoryCards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-bento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatureBento(root) {
      if (root.dataset.fbInit) return;
      root.dataset.fbInit = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      var grid = root.querySelector('[data-fb-grid]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fb-card]'));
      if (!grid || !cards.length) return;

      root.classList.add('js-ready');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      cards.forEach(function (card) { io.observe(card); });
    }

    document.querySelectorAll('[data-fb-root]').forEach(initFeatureBento);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-rows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatureRows(root) {
      if (root.dataset.ftInit) return;
      root.dataset.ftInit = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ft-row]'));
      if (!rows.length) return;

      root.classList.add('js-ready');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      rows.forEach(function (row) { io.observe(row); });
    }

    document.querySelectorAll('[data-ft-root]').forEach(initFeatureRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-scroll-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp01(n) { return Math.min(1, Math.max(0, n)); }

    function initFeatureScrollList(root) {
      if (root.dataset.fslInit) return;
      root.dataset.fslInit = 'true';

      var pin = root.querySelector('[data-fsl-pin]');
      var listViewport = root.querySelector('[data-fsl-list-viewport]');
      var list = root.querySelector('[data-fsl-list]');
      var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-fsl-media-item]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-fsl-item]'));
      var featureCount = mediaItems.length;
      if (!pin || !items.length || !featureCount) return;

      var desktopVideos = mediaItems
        .map(function (item) { return item.querySelector('.fsl-media__video'); })
        .filter(Boolean);
      var mobileVideos = items
        .map(function (item) { return item.querySelector('.fsl-item__mobile-media .fsl-media__video'); })
        .filter(Boolean);

      function playVideo(video) { if (video) video.play().catch(function () {}); }
      function pauseVideo(video) { if (video) video.pause(); }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (items[0]) items[0].classList.add('is-active');
        if (mediaItems[0]) mediaItems[0].classList.add('is-active');
        return;
      }

      root.classList.add('js-ready');

      var mq = window.matchMedia('(min-width: 990px)');
      var scrollHandler = null;
      var mobileIo = null;

      function setActiveMedia(index) {
        mediaItems.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
        desktopVideos.forEach(function (video) {
          var item = video.closest('[data-fsl-media-item]');
          if (item && item.classList.contains('is-active')) playVideo(video); else pauseVideo(video);
        });
      }

      function teardown() {
        if (scrollHandler) {
          window.removeEventListener('scroll', scrollHandler, { capture: true });
          scrollHandler = null;
        }
        if (mobileIo) {
          mobileIo.disconnect();
          mobileIo = null;
        }
        desktopVideos.forEach(pauseVideo);
      }

      function setupPinned() {
        teardown();
        var ticking = false;
        var slots = items.length; // feature items + optional closing item

        function update() {
          var rect = pin.getBoundingClientRect();
          var vh = window.innerHeight;
          var total = rect.height - vh;
          var progress = total > 0 ? clamp01(-rect.top / total) : 0;
          var virtualIndex = progress * (slots - 1);

          // Reel: translate the list so the item at virtualIndex sits
          // centered in the viewport window, interpolating smoothly
          // between neighboring items' measured centers rather than
          // snapping — this is what makes the reel feel scroll-scrubbed
          // instead of stepped.
          var lower = Math.floor(virtualIndex);
          var upper = Math.min(slots - 1, lower + 1);
          var frac = virtualIndex - lower;
          var lowerCenter = items[lower].offsetTop + items[lower].offsetHeight / 2;
          var upperCenter = items[upper].offsetTop + items[upper].offsetHeight / 2;
          var center = lowerCenter + (upperCenter - lowerCenter) * frac;
          var viewportCenter = listViewport.clientHeight / 2;
          list.style.transform = 'translateY(' + (viewportCenter - center) + 'px)';

          items.forEach(function (item, i) {
            var distance = Math.abs(i - virtualIndex);
            item.classList.toggle('is-active', distance < 0.5);
            item.style.opacity = String(Math.max(0.16, 1 - distance * 0.4));
          });

          var mediaIndex = Math.min(featureCount - 1, Math.round(virtualIndex));
          setActiveMedia(mediaIndex);
        }

        scrollHandler = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        };

        window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
        update();
      }

      function setupMobile() {
        teardown();
        if (mobileVideos.length && 'IntersectionObserver' in window) {
          mobileIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) playVideo(entry.target); else pauseVideo(entry.target);
            });
          }, { threshold: 0.4 });
          mobileVideos.forEach(function (video) { mobileIo.observe(video); });
        }
      }

      function applyMode() {
        if (mq.matches) setupPinned(); else setupMobile();
      }

      applyMode();
      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);
    }

    document.querySelectorAll('[data-fsl-root]').forEach(initFeatureScrollList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function enhanceSpecItem(details) {
      var summary = details.querySelector('summary');
      var body = details.querySelector('[data-fps-spec-body]');
      if (!summary || !body) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = details.hasAttribute('open');

        if (isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () {
            body.style.maxHeight = '0px';
          });
          body.addEventListener('transitionend', function onClose() {
            details.removeAttribute('open');
            body.removeEventListener('transitionend', onClose);
          }, { once: true });
        } else {
          details.setAttribute('open', '');
          body.style.maxHeight = '0px';
          requestAnimationFrame(function () {
            body.style.maxHeight = body.scrollHeight + 'px';
          });
          body.addEventListener('transitionend', function onOpen() {
            body.style.maxHeight = '';
            body.removeEventListener('transitionend', onOpen);
          }, { once: true });
        }
      });
    }

    function initFeaturedProductSpotlight(root) {
      if (root.dataset.fpsInit) return;
      root.dataset.fpsInit = 'true';

      var mainImg = root.querySelector('[data-fps-main-img]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fps-thumb]'));

      // Whole-card click-through to the product page — anywhere except
      // actual interactive controls (buy button, quantity stepper,
      // thumbnails, coupon copy button, the specs accordion, or any
      // other link/button/form field) forwards to the PDP. Not a real
      // wrapping <a> because this card contains buttons and a <details>
      // accordion — nesting interactive elements inside an anchor is
      // invalid HTML and makes click targeting unreliable, so this does
      // the same job via JS.
      var cardUrl = root.getAttribute('data-fps-card-url');
      if (cardUrl) {
        root.addEventListener('click', function (e) {
          if (e.target.closest('a, button, input, select, textarea, summary, details')) return;
          if (window.getSelection && String(window.getSelection())) return;
          window.location.href = cardUrl;
        });
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion) {
        root.classList.add('js-ready');

        if ('IntersectionObserver' in window) {
          var revealIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                root.classList.add('is-in');
                revealIo.unobserve(root);
              }
            });
          }, { threshold: 0.2 });
          revealIo.observe(root);
        } else {
          root.classList.add('is-in');
        }

        if (mainImg) {
          var ticking = false;
          var PARALLAX_RANGE = 22;

          function updateParallax() {
            var rect = root.getBoundingClientRect();
            var vh = window.innerHeight;
            var mid = rect.top + rect.height / 2;
            var progress = Math.min(1, Math.max(-1, (vh / 2 - mid) / (vh / 2 + rect.height / 2)));
            mainImg.style.transform = 'translateY(' + (progress * PARALLAX_RANGE) + 'px)';
            ticking = false;
          }

          window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(updateParallax);
          }, { capture: true, passive: true });

          updateParallax();
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.src = thumb.getAttribute('data-full');
          thumbs.forEach(function (t) { t.classList.remove('fps-thumb--active'); });
          thumb.classList.add('fps-thumb--active');
        });
      });

      root.querySelectorAll('[data-fps-spec-item]').forEach(enhanceSpecItem);

      var status = root.querySelector('[data-fps-status]');
      function announce(msg) {
        if (status) status.textContent = msg;
      }

      function refreshCartDrawer() {
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper) return Promise.resolve();
        return fetch(window.location.pathname + '?sections=cart-drawer-section')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data['cart-drawer-section']) {
              wrapper.outerHTML = data['cart-drawer-section'];
            }
          })
          .catch(function () {});
      }

      function openCartDrawer() {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (e) {}
        }
      }

      var qtyInput = root.querySelector('[data-fps-qty-input]');
      var qtyMinus = root.querySelector('[data-fps-qty-minus]');
      var qtyPlus = root.querySelector('[data-fps-qty-plus]');
      if (qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = v;
        });
        qtyPlus.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
          qtyInput.value = v;
        });
      }

      var buyBtn = root.querySelector('[data-fps-quick-add]');
      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          if (buyBtn.hasAttribute('data-fps-loading')) return;
          buyBtn.setAttribute('data-fps-loading', '');

          var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: buyBtn.getAttribute('data-variant-id'), quantity: quantity }] })
          })
            .then(function (res) {
              return res.json().then(function (data) { return { ok: res.ok, data: data }; });
            })
            .then(function (result) {
              buyBtn.removeAttribute('data-fps-loading');
              if (!result.ok) {
                announce((result.data && result.data.description) || 'Could not add this item to your cart.');
                return;
              }
              announce('Added to cart.');
              refreshCartDrawer().then(openCartDrawer);
            })
            .catch(function () {
              buyBtn.removeAttribute('data-fps-loading');
              announce('Something went wrong adding this item to your cart.');
            });
        });
      }
    }

    document.querySelectorAll('[data-fps-root]').forEach(initFeaturedProductSpotlight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider(root) {
      if (root.dataset.hsInit) return;
      root.dataset.hsInit = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
      if (slides.length < 2) return;

      var interval = parseInt(root.getAttribute('data-hs-interval'), 10) || 5000;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var playing = !reduceMotion;
      var idx = 0;
      var timer = null;
      var pauseBtn = root.querySelector('[data-hs-pause]');

      function setActive(next) {
        slides[idx].classList.remove('is-active');
        slides[idx].setAttribute('aria-hidden', 'true');
        slides[idx].setAttribute('inert', '');
        idx = (next + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        slides[idx].removeAttribute('aria-hidden');
        slides[idx].removeAttribute('inert');
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      function start() {
        if (!playing) return;
        stop();
        timer = setInterval(function () { setActive(idx + 1); }, interval);
      }

      function syncPauseButton() {
        if (!pauseBtn) return;
        pauseBtn.setAttribute('aria-pressed', String(!playing));
        pauseBtn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
      }

      syncPauseButton();
      start();

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', function () { if (playing) start(); });
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function () { if (playing) start(); });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          playing = !playing;
          syncPauseButton();
          if (playing) start(); else stop();
        });
      }

      var touchStartX = null;
      root.addEventListener('touchstart', function (evt) {
        touchStartX = evt.touches[0].clientX;
        stop();
      }, { passive: true });

      root.addEventListener('touchend', function (evt) {
        if (touchStartX === null) return;
        var dx = evt.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          setActive(dx < 0 ? idx + 1 : idx - 1);
        }
        touchStartX = null;
        if (playing) start();
      }, { passive: true });

      root.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowRight') setActive(idx + 1);
        if (evt.key === 'ArrowLeft') setActive(idx - 1);
      });
    }

    document.querySelectorAll('[data-hs-root]').forEach(initHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroVideo(root) {
      if (root.dataset.hvInit) return;
      root.dataset.hvInit = 'true';
      var video = root.querySelector('.hv-video');
      if (video) {
        video.muted = true;
        video.play().catch(function () {});
      }

      var slideshow = root.querySelector('[data-hv-slideshow]');
      if (slideshow) {
        var slides = Array.prototype.slice.call(slideshow.querySelectorAll('[data-hv-slide]'));
        if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var seconds = parseFloat(slideshow.style.getPropertyValue('--hv-slide-seconds')) || 0.2;
          // Reset explicitly rather than trusting the Liquid-rendered
          // "is-active" class to line up with index 0 — guarantees this
          // loop's own index always matches the actually-active slide,
          // so the wrap from the last slide back to the first can't
          // land on the wrong one.
          slides.forEach(function (s) { s.classList.remove('is-active'); });
          var index = 0;
          slides[index].classList.add('is-active');

          setInterval(function () {
            slides[index].classList.remove('is-active');
            index = (index + 1) % slides.length;
            slides[index].classList.add('is-active');
          }, seconds * 1000);
        }
      }
    }
    document.querySelectorAll('[data-hv-root]').forEach(initHeroVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLifestyleBanner(root) {
      if (root.dataset.lbInit) return;
      root.dataset.lbInit = 'true';

      if (root.dataset.lbZoom !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-zoomed');
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });

      io.observe(root);
    }

    document.querySelectorAll('[data-lb-root]').forEach(initLifestyleBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initManifesto(root) {
      if (root.dataset.manInit) return;
      root.dataset.manInit = 'true';

      var pin = root.querySelector('[data-man-pin]');
      var words = Array.prototype.slice.call(root.querySelectorAll('[data-man-word]'));
      if (!pin || !words.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      root.classList.add('js-ready');

      var mq = window.matchMedia('(min-width: 990px)');
      var scrollHandler = null;

      function setProgress(progress) {
        var revealCount = Math.min(words.length, Math.round(progress * words.length));
        words.forEach(function (word, i) {
          word.classList.toggle('is-revealed', i < revealCount);
        });
      }

      function teardown() {
        if (scrollHandler) {
          window.removeEventListener('scroll', scrollHandler, { capture: true });
          scrollHandler = null;
        }
      }

      function setupPinned() {
        teardown();
        var ticking = false;

        function update() {
          var rect = pin.getBoundingClientRect();
          var vh = window.innerHeight;
          var total = rect.height - vh;
          var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
          setProgress(progress);
        }

        scrollHandler = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        };

        window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
        update();
      }

      function setupMobile() {
        teardown();
        words.forEach(function (word) { word.classList.add('is-revealed'); });
      }

      function applyMode() {
        if (mq.matches) setupPinned(); else setupMobile();
      }

      applyMode();
      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);
    }

    document.querySelectorAll('[data-man-root]').forEach(initManifesto);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp01(n) { return Math.min(1, Math.max(0, n)); }

    function initMaterialStory(root) {
      if (root.dataset.msInit) return;
      root.dataset.msInit = 'true';

      var pin = root.querySelector('[data-ms-pin]');
      var sticky = root.querySelector('[data-ms-sticky]');
      var viewport = root.querySelector('[data-ms-viewport]');
      var track = root.querySelector('[data-ms-track]');
      if (!pin || !sticky || !viewport || !track) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      root.classList.add('js-ready');

      var mq = window.matchMedia('(min-width: 990px)');
      var scrollHandler = null;
      var resizeHandler = null;
      var maxTranslate = 0;

      function headerOffset() {
        var v = getComputedStyle(document.body).getPropertyValue('--header-height');
        return parseFloat(v) || 0;
      }

      function measure() {
        var insetPx = parseFloat(getComputedStyle(viewport).paddingLeft) || 0;
        maxTranslate = Math.max(0, track.scrollWidth - (viewport.clientWidth - insetPx));
        var stickyHeight = sticky.getBoundingClientRect().height;
        pin.style.height = (stickyHeight + maxTranslate) + 'px';
      }

      function update() {
        var rect = pin.getBoundingClientRect();
        var stickyHeight = sticky.getBoundingClientRect().height;
        var total = rect.height - stickyHeight;
        var progress = total > 0 ? clamp01((headerOffset() - rect.top) / total) : 0;
        track.style.transform = 'translateX(' + (-progress * maxTranslate) + 'px)';
      }

      function teardown() {
        if (scrollHandler) {
          window.removeEventListener('scroll', scrollHandler, { capture: true });
          scrollHandler = null;
        }
        if (resizeHandler) {
          window.removeEventListener('resize', resizeHandler);
          resizeHandler = null;
        }
        track.style.transform = '';
        pin.style.height = '';
      }

      function setupPinned() {
        teardown();
        // Scroll-snap on the mobile/fallback viewport can leave a native
        // scrollLeft in place even after switching to overflow:hidden —
        // positioning here is fully transform-driven, so any leftover
        // native scroll offset would silently shift everything.
        viewport.scrollLeft = 0;
        measure();
        var ticking = false;

        scrollHandler = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        };
        resizeHandler = function () {
          measure();
          update();
        };

        window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
        window.addEventListener('resize', resizeHandler);
        update();
      }

      function setupMobile() {
        teardown();
      }

      function applyMode() {
        if (mq.matches) setupPinned(); else setupMobile();
      }

      applyMode();
      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);
    }

    document.querySelectorAll('[data-ms-root]').forEach(initMaterialStory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Runs once, sitewide (not per header instance).

       Horizon's own <theme-drawer> deliberately opens the cart as a
       non-modal dialog ("squeeze" mode) on viewports >= 990px, and only
       uses a true modal (with native backdrop/dimming) below that width —
       see theme-drawer.js: `this.#modalQuery.matches ? panel.showModal() :
       panel.show()`. That's intentional theme behavior, not a bug, so we
       leave Horizon's own open()/close()/showModal()/show() calls
       completely untouched — forcing showModal() ourselves fights its
       internal state (scroll-lock, focus-trap, animation bookkeeping) and
       causes the dialog to render incorrectly (confirmed: it can end up
       positioned entirely off-screen).

       Instead, on desktop we just add our own purely-cosmetic dimmed
       backdrop behind the untouched, still-non-modal dialog, and nudge its
       position to sit below our header instead of overlapping it. Nothing
       here reads or writes Horizon's open/closed state. */
    function setupCartDrawerBackdrop() {
      if (window.__mhCartBackdropSetup) return;
      window.__mhCartBackdropSetup = true;

      var backdrop = document.createElement('div');
      backdrop.className = 'mh-cart-backdrop';
      backdrop.hidden = true;
      backdrop.addEventListener('click', function () {
        var themeDrawer = document.getElementById('cart-drawer');
        if (themeDrawer && typeof themeDrawer.close === 'function') themeDrawer.close();
      });
      document.body.appendChild(backdrop);

      function positionBelowHeader(dialogEl) {
        var headerBar = document.querySelector('.mh-bar');
        if (!headerBar) return;
        var top = Math.round(headerBar.getBoundingClientRect().bottom + 8);
        dialogEl.style.top = top + 'px';
        // Horizon sets a fixed height for squeeze mode independent of "top",
        // so pushing it down without also shrinking it would let it overflow
        // past the bottom of the viewport.
        dialogEl.style.height = 'calc(100vh - ' + (top + 12) + 'px)';
      }

      // Horizon slides the dialog in with a short CSS animation. Setting
      // inline styles (like our top/height above) on the dialog *during*
      // that animation interrupts it, freezing it at its off-screen starting
      // position — confirmed by testing. So we wait for the animation to
      // actually finish before touching anything, the same way Horizon's
      // own code waits via onAnimationEnd.
      function afterOpenAnimation(dialogEl, callback) {
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          callback();
        }
        dialogEl.addEventListener('animationend', finish, { once: true });
        // Safety net in case no animation runs (reduced motion, etc.).
        setTimeout(finish, 250);
      }

      function refreshOwnBadges() {
        fetch('/cart.js', { headers: { accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-mh-cart-badge]').forEach(function (badge) {
              badge.textContent = cart.item_count;
              badge.hidden = cart.item_count === 0;
            });
          });
      }

      // When Essential Cart Drawer is the active cart UI, our header's own
      // badge count needs to stay in sync with whatever happens inside its
      // drawer (add/remove/qty change), since none of that touches Horizon's
      // native #cart-drawer at all. Refetch /cart.js (universal Shopify
      // endpoint) rather than trusting the shape of the app's own callback
      // data, so this doesn't depend on undocumented internals.
      if (window.essentialCartApi && typeof window.essentialCartApi.onCartUpdate === 'function') {
        window.essentialCartApi.onCartUpdate(refreshOwnBadges);
      }

      function handleDialogState(el) {
        if (!(el instanceof HTMLElement) || el.tagName !== 'DIALOG' || !el.closest('#cart-drawer')) return;
        if (el.hasAttribute('open')) {
          if (!el.matches(':modal')) {
            // Non-modal ("squeeze") mode: it has no native backdrop, so add ours.
            backdrop.hidden = false;
            requestAnimationFrame(function () { backdrop.classList.add('is-visible'); });
            afterOpenAnimation(el, function () { positionBelowHeader(el); });
          }
          // Modal mode already has its own native ::backdrop — nothing to add.
        } else {
          backdrop.classList.remove('is-visible');
          window.setTimeout(function () { backdrop.hidden = true; }, 200);
          refreshOwnBadges();
        }
      }

      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) { handleDialogState(m.target); });
      }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });

      // Horizon restores the drawer's open/closed state from sessionStorage
      // on every page load — which can happen *before* this script runs, so
      // the observer above would never see that initial mutation.
      var existingDialog = document.querySelector('#cart-drawer dialog');
      if (existingDialog) handleDialogState(existingDialog);
    }

    /* Runs once, sitewide. Horizon's own sticky-content system (used by the
       product page: whichever of the media/details column is shorter
       becomes "position: sticky; top: var(--header-height, 0)") expects a
       native header component to set "--header-height" via its own JS.
       Our mega-header replaces that native header entirely, so nothing was
       ever setting this variable — in overlay/transparent mode (the
       default: "enable_overlay" true, header is "position: fixed") that
       left every sticky-content element pinning at the very top of the
       viewport, underneath the floating header, instead of below it.
       Measuring our own header's rendered height and exposing it as the
       same "--header-height" variable fixes that everywhere Horizon reads
       it, with no changes needed on the product page side. A
       ResizeObserver (rather than a one-off measurement) keeps it correct
       across viewport size changes and if the announcement bar disappears. */
    function setupHeaderHeightVar(root) {
      if (window.__mhHeaderHeightSetup) return;
      window.__mhHeaderHeightSetup = true;

      function applyHeight() {
        /* Only overlay/transparent headers are "position: fixed" and taken
           out of flow, so only they need an offset — a non-overlay header
           already pushes page content down on its own, and adding the
           height again here would double it up. Setting an explicit "0px"
           (rather than leaving the variable undefined) guarantees it's
           always validly defined either way. */
        if (!root.classList.contains('mh-root--overlay')) {
          document.documentElement.style.setProperty('--header-height', '0px');
          return;
        }
        var height = root.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--header-height', Math.round(height) + 'px');
      }

      if (window.ResizeObserver) {
        new ResizeObserver(applyHeight).observe(root);
      } else {
        window.addEventListener('resize', applyHeight, { passive: true });
      }
      applyHeight();
    }

    function initMegaHeader(root) {
      if (root.dataset.mhInit) return;
      root.dataset.mhInit = 'true';

      setupHeaderHeightVar(root);

      /* Transparent-on-load header (homepage only). The "at-top" class is
         already present server-side for first paint; this just keeps it in
         sync with real scroll position (e.g. page loaded mid-scroll via
         back/forward navigation, or an anchor link).

         Horizon's own ".page-wrapper" (theme.liquid) is set to
         "overflow-y: auto" and is the element that actually scrolls — the
         window/document itself never does — so the listener has to go on
         page-wrapper, not window. Falls back to window if that wrapper
         isn't found, in case a future theme.liquid change removes it. */
      if (root.hasAttribute('data-mh-transparent-home')) {
        var MH_TRANSPARENT_THRESHOLD = 40;
        // Don't start hiding until scrolled a bit past the top — avoids
        // the header flickering hidden from a tiny/accidental scroll
        // right at the top of the page.
        var MH_HIDE_THRESHOLD = 120;
        var mhScrollEl = document.querySelector('.page-wrapper') || window;
        var mhLastY = mhScrollEl === window ? window.scrollY : mhScrollEl.scrollTop;
        var updateTransparentState = function () {
          var y = mhScrollEl === window ? window.scrollY : mhScrollEl.scrollTop;
          root.classList.toggle('mh-root--at-top', y < MH_TRANSPARENT_THRESHOLD);

          if (y < MH_HIDE_THRESHOLD) {
            root.classList.remove('mh-root--hidden');
          } else if (y > mhLastY) {
            root.classList.add('mh-root--hidden');
          } else if (y < mhLastY) {
            root.classList.remove('mh-root--hidden');
          }
          mhLastY = y;
        };
        updateTransparentState();
        mhScrollEl.addEventListener('scroll', updateTransparentState, { passive: true });
      }

      var triggers = root.querySelectorAll('[data-mh-trigger]');
      var scrollLockCount = 0;

      /* Prefer whichever cart UI is actually the "real" one over our own
         fallback popover, so nothing we build ever duplicates or conflicts
         with app functionality:

         1. Essential Cart Drawer (confirmed installed) replaces Horizon's
            native drawer with its own element and *forcibly hides* the
            original #cart-drawer via CSS — calling #cart-drawer.open()
            would open a drawer the app has made invisible. It exposes a
            public API (window.essentialCartApi) instead; use that when present.
         2. Otherwise, Horizon's own native #cart-drawer (untouched markup,
            so any other app's injected content keeps working).
         3. Otherwise, our own fallback popover. */
      function tryOpenNativeCart() {
        if (window.essentialCartApi && typeof window.essentialCartApi.openCart === 'function') {
          window.essentialCartApi.openCart();
          return true;
        }
        var d = document.getElementById('cart-drawer');
        if (d && typeof d.open === 'function') {
          d.open();
          return true;
        }
        return false;
      }

      setupCartDrawerBackdrop();

      function panelFor(trigger) {
        var id = trigger.getAttribute('aria-controls');
        return id ? document.getElementById(id) : null;
      }

      function closeAllPopovers(except) {
        triggers.forEach(function (t) {
          if (t === except) return;
          clearTimeout(t._mhCloseTimer);
          var panel = panelFor(t);
          if (panel && panel.hasAttribute('data-mh-panel') && !panel.hidden) {
            panel.hidden = true;
            t.setAttribute('aria-expanded', 'false');
          }
        });
      }

      function lockScroll() {
        scrollLockCount++;
        if (scrollLockCount > 1) return;
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
      }

      function unlockScroll() {
        scrollLockCount = Math.max(0, scrollLockCount - 1);
        if (scrollLockCount > 0) return;
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }

      function trapFocus(container, evt) {
        var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (evt.shiftKey && document.activeElement === first) {
          evt.preventDefault();
          last.focus();
        } else if (!evt.shiftKey && document.activeElement === last) {
          evt.preventDefault();
          first.focus();
        }
      }

      function openHoverPanel(trigger) {
        clearTimeout(trigger._mhCloseTimer);
        var panel = panelFor(trigger);
        if (!panel) return;
        closeAllPopovers(trigger);
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }

      function scheduleCloseHoverPanel(trigger) {
        clearTimeout(trigger._mhCloseTimer);
        trigger._mhCloseTimer = setTimeout(function () {
          var panel = panelFor(trigger);
          if (panel) panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }, 200);
      }

      triggers.forEach(function (trigger) {
        var type = trigger.getAttribute('data-mh-trigger');

        if (type === 'hover') {
          var panel = panelFor(trigger);
          trigger.addEventListener('mouseenter', function () { openHoverPanel(trigger); });
          trigger.addEventListener('mouseleave', function () { scheduleCloseHoverPanel(trigger); });
          trigger.addEventListener('focus', function () { openHoverPanel(trigger); });
          trigger.addEventListener('blur', function () { scheduleCloseHoverPanel(trigger); });
          if (panel) {
            panel.addEventListener('mouseenter', function () { clearTimeout(trigger._mhCloseTimer); });
            panel.addEventListener('mouseleave', function () { scheduleCloseHoverPanel(trigger); });
          }
          return;
        }

        if (type === 'drawer-cart') {
          // Handled separately below (needs to close the drawer first).
          return;
        }

        trigger.addEventListener('click', function () {
          if (type === 'drawer') {
            openDrawer();
            return;
          }
          if (type === 'mobile-search') {
            openMobileSearch();
            return;
          }
          if (type === 'cart') {
            if (tryOpenNativeCart()) return;
            // fall through to the generic popover toggle below (our own fallback cart UI)
          }

          var panel = panelFor(trigger);
          if (!panel) return;
          var isOpen = !panel.hidden;
          closeAllPopovers(trigger);
          panel.hidden = isOpen;
          trigger.setAttribute('aria-expanded', String(!isOpen));
          if (!isOpen) {
            if (type === 'cart') loadCart(panel);
            var focusTarget = panel.querySelector('input, a, button');
            if (focusTarget) focusTarget.focus();
          }
        });
      });

      root.querySelectorAll('[data-mh-panel-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.closest('[data-mh-panel]');
          if (panel) panel.hidden = true;
          closeAllPopovers(null);
        });
      });

      document.addEventListener('click', function (evt) {
        var withinTrigger = evt.target.closest('[data-mh-trigger]');
        var withinPanel = evt.target.closest('[data-mh-panel]');
        if (!withinTrigger && !withinPanel) closeAllPopovers(null);
      });

      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') {
          closeAllPopovers(null);
          closeMobileSearch();
          closeDrawer();
        }
        var openDialog = root.querySelector('.mh-drawer:not([hidden]) .mh-drawer__sheet, .mh-mobile-search:not([hidden])');
        if (evt.key === 'Tab' && openDialog) trapFocus(openDialog, evt);
      });

      /* Drawer (3-level) */
      var drawer = root.querySelector('[data-mh-drawer]');
      var drawerTrigger = root.querySelector('[data-mh-trigger="drawer"]');
      var stack = ['root'];

      function showPanel(key) {
        drawer.querySelectorAll('[data-mh-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-mh-panel') !== key;
        });
        var current = drawer.querySelector('[data-mh-panel="' + key + '"]');
        var titleEl = drawer.querySelector('[data-mh-level-title]');
        var backBtn = drawer.querySelector('[data-mh-back]');
        if (titleEl) titleEl.textContent = current ? current.getAttribute('data-mh-title') : '';
        if (backBtn) backBtn.hidden = stack.length <= 1;
      }

      function openDrawer() {
        stack = ['root'];
        showPanel('root');
        drawer.hidden = false;
        lockScroll();

        // Position the drawer to start right below the header (same spacing
        // logic as the desktop mega menu: header bottom + a small gap),
        // instead of a fixed viewport offset that could get clipped under it.
        var sheet = drawer.querySelector('.mh-drawer__sheet');
        var headerBar = root.querySelector('.mh-bar');
        if (sheet && headerBar) {
          sheet.style.top = Math.round(headerBar.getBoundingClientRect().bottom + 8) + 'px';
        }

        requestAnimationFrame(function () { drawer.setAttribute('data-mh-open', ''); });
        var closeBtn = drawer.querySelector('[data-mh-drawer-close]');
        if (closeBtn) closeBtn.focus();
        drawerTrigger.setAttribute('aria-expanded', 'true');
      }

      function closeDrawer() {
        if (!drawer || drawer.hidden) return;
        drawer.removeAttribute('data-mh-open');
        unlockScroll();
        drawerTrigger.setAttribute('aria-expanded', 'false');
        drawerTrigger.focus();
        window.setTimeout(function () { drawer.hidden = true; }, 250);
      }

      if (drawer) {
        drawer.querySelectorAll('[data-mh-open]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = btn.getAttribute('data-mh-open');
            stack.push(key);
            showPanel(key);
          });
        });
        var backBtn = drawer.querySelector('[data-mh-back]');
        if (backBtn) {
          backBtn.addEventListener('click', function () {
            if (stack.length > 1) stack.pop();
            showPanel(stack[stack.length - 1]);
          });
        }
        drawer.querySelectorAll('[data-mh-drawer-close]').forEach(function (btn) {
          btn.addEventListener('click', closeDrawer);
        });
      }

      /* Mobile search overlay */
      var mobileSearch = root.querySelector('[data-mh-mobile-search]');

      function openMobileSearch() {
        if (!mobileSearch) return;
        mobileSearch.hidden = false;
        lockScroll();
        var input = mobileSearch.querySelector('input');
        if (input) input.focus();
      }

      function closeMobileSearch() {
        if (!mobileSearch || mobileSearch.hidden) return;
        mobileSearch.hidden = true;
        unlockScroll();
      }

      if (mobileSearch) {
        mobileSearch.querySelectorAll('[data-mh-mobile-search-close]').forEach(function (btn) {
          btn.addEventListener('click', closeMobileSearch);
        });
      }

      /* Cart popover, built on Shopify's standard Ajax Cart API (/cart.js,
         /cart/change.js) so it doesn't depend on the theme's own cart
         drawer internals at all. */
      function escapeHtml(str) {
        return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function cdnResize(url, width) {
        if (!url) return '';
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      function updateCartBadges(count) {
        document.querySelectorAll('[data-mh-cart-badge]').forEach(function (badge) {
          badge.textContent = count;
          badge.hidden = count === 0;
        });
      }

      function renderCart(cart) {
        var panel = document.querySelector('.mh-popover--cart');
        var body = panel && panel.querySelector('[data-mh-cart-body]');
        if (!body) return;

        if (!cart.items.length) {
          body.innerHTML = '<p class="mh-cart-empty">Your cart is empty.</p>';
          return;
        }

        var money;
        try {
          money = new Intl.NumberFormat(undefined, { style: 'currency', currency: cart.currency });
        } catch (e) {
          money = { format: function (v) { return (cart.currency || '') + ' ' + v.toFixed(2); } };
        }

        var itemsHtml = cart.items.map(function (item, idx) {
          return (
            '<li class="mh-cart-item" data-mh-cart-line="' + (idx + 1) + '">' +
              '<img class="mh-cart-item__img" src="' + escapeHtml(cdnResize(item.image, 112)) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' +
              '<div class="mh-cart-item__body">' +
                '<p class="mh-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
                (item.variant_title ? '<p class="mh-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
                '<div class="mh-cart-item__qty">' +
                  '<button type="button" class="mh-cart-qty-btn" data-mh-cart-qty="-1" aria-label="Decrease quantity">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" class="mh-cart-qty-btn" data-mh-cart-qty="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
              '</div>' +
              '<div class="mh-cart-item__side">' +
                '<p class="mh-cart-item__price">' + money.format(item.final_line_price / 100) + '</p>' +
                '<button type="button" class="mh-cart-item__remove" aria-label="Remove ' + escapeHtml(item.product_title) + '">' +
                  '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
              '</div>' +
            '</li>'
          );
        }).join('');

        body.innerHTML =
          '<ul class="mh-cart-items">' + itemsHtml + '</ul>' +
          '<div class="mh-cart-subtotal"><span>Subtotal</span><span>' + money.format(cart.items_subtotal_price / 100) + '</span></div>' +
          '<a href="/checkout" class="mh-cart-checkout">Secure Checkout</a>';
      }

      function fetchCart() {
        return fetch('/cart.js', { headers: { accept: 'application/json' } }).then(function (r) { return r.json(); });
      }

      function loadCart(panel) {
        var body = panel.querySelector('[data-mh-cart-body]');
        if (body) body.innerHTML = '<p class="mh-cart-loading">Loading…</p>';
        fetchCart().then(function (cart) {
          updateCartBadges(cart.item_count);
          renderCart(cart);
        });
      }

      function changeCartLine(line, quantity, itemEl) {
        if (itemEl) itemEl.classList.add('mh-cart-item--updating');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartBadges(cart.item_count);
            renderCart(cart);
          });
      }

      var cartPanel = document.querySelector('.mh-popover--cart');
      if (cartPanel) {
        cartPanel.addEventListener('click', function (evt) {
          var qtyBtn = evt.target.closest('[data-mh-cart-qty]');
          var removeBtn = evt.target.closest('.mh-cart-item__remove');
          if (!qtyBtn && !removeBtn) return;

          var itemEl = (qtyBtn || removeBtn).closest('[data-mh-cart-line]');
          var line = parseInt(itemEl.getAttribute('data-mh-cart-line'), 10);

          if (removeBtn) {
            changeCartLine(line, 0, itemEl);
            return;
          }

          var qtyText = itemEl.querySelector('.mh-cart-item__qty span').textContent;
          var newQty = parseInt(qtyText, 10) + parseInt(qtyBtn.getAttribute('data-mh-cart-qty'), 10);
          changeCartLine(line, Math.max(0, newQty), itemEl);
        });
      }

      /* The drawer's own cart button closes the drawer first, then opens
         the cart popover, since both can't usefully be open at once. */
      if (drawer) {
        var drawerCartBtn = drawer.querySelector('[data-mh-trigger="drawer-cart"]');
        if (drawerCartBtn) {
          drawerCartBtn.addEventListener('click', function () {
            closeDrawer();
            window.setTimeout(function () {
              if (tryOpenNativeCart()) return;
              if (cartPanel) {
                cartPanel.hidden = false;
                loadCart(cartPanel);
              }
            }, 260);
          });
        }
      }
    }

    document.querySelectorAll('[data-mh-root]').forEach(initMegaHeader);

    // In the Shopify theme editor, sections can be re-rendered in place
    // (e.g. after a settings change) without a full page reload, which
    // replaces our header's markup with a fresh, un-initialized copy.
    // Re-run init whenever that happens so hover menus, the drawer, and
    // the cart-drawer backdrop keep working inside the editor.
    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target.querySelector && evt.target.querySelector('[data-mh-root]');
      if (root) initMegaHeader(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-banner-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductBannerImage(root) {
      if (root.dataset.pbiInit) return;
      root.dataset.pbiInit = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('js-ready');

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.unobserve(root);
            }
          });
        }, { threshold: 0.2 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }

      var img = root.querySelector('[data-pbi-img]');
      if (!img) return;
      var ticking = false;
      var PARALLAX_RANGE = 22;

      function update() {
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight;
        var mid = rect.top + rect.height / 2;
        var progress = Math.min(1, Math.max(-1, (vh / 2 - mid) / (vh / 2 + rect.height / 2)));
        img.style.transform = 'translateY(' + (progress * PARALLAX_RANGE) + 'px)';
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { capture: true, passive: true });

      update();
    }

    document.querySelectorAll('[data-pbi-root]').forEach(initProductBannerImage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function enhanceFaqItem(details) {
      var summary = details.querySelector('summary');
      var answer = details.querySelector('[data-faq-answer]');
      if (!summary || !answer) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = details.hasAttribute('open');

        if (isOpen) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          requestAnimationFrame(function () {
            answer.style.maxHeight = '0px';
          });
          answer.addEventListener('transitionend', function onClose() {
            details.removeAttribute('open');
            answer.removeEventListener('transitionend', onClose);
          }, { once: true });
        } else {
          details.setAttribute('open', '');
          answer.style.maxHeight = '0px';
          requestAnimationFrame(function () {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          });
          answer.addEventListener('transitionend', function onOpen() {
            answer.style.maxHeight = '';
            answer.removeEventListener('transitionend', onOpen);
          }, { once: true });
        }
      });
    }

    document.querySelectorAll('[data-faq-item]').forEach(enhanceFaqItem);

    function initFaqReveal(root) {
      if (root.dataset.faqRevealInit) return;
      root.dataset.faqRevealInit = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('js-ready');

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.unobserve(root);
            }
          });
        }, { threshold: 0.15 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }
    }

    document.querySelectorAll('[data-faq-root]').forEach(initFaqReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initScrub(media) {
      var imgs = media.querySelectorAll('[data-pr-scrub-img]');
      var dots = media.parentElement ? media.parentElement.querySelectorAll('[data-pr-dots] .pr-dot') : [];
      if (imgs.length < 2) return;
      function setActive(idx) {
        imgs.forEach(function (img, i) { img.classList.toggle('pr-img--active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('pr-dot--active', i === idx); });
      }
      media.addEventListener('mousemove', function (evt) {
        var rect = media.getBoundingClientRect();
        var relX = (evt.clientX - rect.left) / rect.width;
        relX = Math.max(0, Math.min(0.999, relX));
        setActive(Math.floor(relX * imgs.length));
      });
      media.addEventListener('mouseleave', function () { setActive(0); });
    }

    function initModalGallery(scope) {
      var imgs = scope.querySelectorAll('[data-pr-qv-img]');
      var dots = scope.querySelectorAll('[data-pr-qv-dot]');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          imgs.forEach(function (img, i) { img.classList.toggle('pr-img--active', i === idx); });
          dots.forEach(function (d) { d.classList.remove('pr-dot--active'); });
          dot.classList.add('pr-dot--active');
        });
      });
    }

    function initQty(scope) {
      var wrap = scope.querySelector('[data-pr-qty]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-pr-qty-input]');
      var minus = wrap.querySelector('[data-pr-qty-minus]');
      var plus = wrap.querySelector('[data-pr-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    }

    function getQty(scope) {
      var input = scope.querySelector('[data-pr-qty-input]');
      return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
    }

    function initProductRow(root) {
      if (root.dataset.prInit) return;
      root.dataset.prInit = 'true';

      root.querySelectorAll('[data-pr-media]').forEach(initScrub);

      var track = root.querySelector('[data-pr-track]');
      var prev = root.querySelector('[data-pr-prev]');
      var next = root.querySelector('[data-pr-next]');
      var status = root.querySelector('[data-pr-status]');
      function announce(msg) { if (status) status.textContent = msg; }

      if (track && (prev || next)) {
        var cardDelta = function () {
          var card = track.querySelector('[data-pr-card]');
          if (!card) return 300;
          var style = getComputedStyle(track);
          var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
          return card.getBoundingClientRect().width + gap;
        };
        var updateArrows = function () {
          if (!prev || !next) return;
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          prev.disabled = track.scrollLeft <= 0;
          next.disabled = track.scrollLeft >= maxScroll;
        };
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardDelta(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardDelta(), behavior: 'smooth' }); });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      function refreshCartDrawer() {
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper) return;
        fetch(window.location.pathname + '?sections=cart-drawer-section')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data['cart-drawer-section']) wrapper.outerHTML = data['cart-drawer-section'];
            var drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              try { drawer.open(); } catch (e) {}
            }
          })
          .catch(function () {});
      }

      function bindAddButton(btn) {
        if (btn.dataset.prBound) return;
        btn.dataset.prBound = 'true';
        var isTextButton = btn.classList.contains('pr-qv__add');
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('data-loading')) return;
          btn.setAttribute('data-loading', '');
          var originalText = btn.textContent;
          var qty = getQty(btn.closest('.pr-qv__info') || document.body);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: btn.getAttribute('data-variant-id'), quantity: qty }] })
          })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (result) {
              btn.removeAttribute('data-loading');
              if (!result.ok) {
                announce((result.data && result.data.description) || 'Could not add this item to your cart.');
                return;
              }
              announce('Added to cart.');
              refreshCartDrawer();
              if (isTextButton) {
                btn.textContent = 'Added';
                window.setTimeout(function () { btn.textContent = originalText; }, 2000);
              } else {
                btn.classList.add('is-added');
                window.setTimeout(function () { btn.classList.remove('is-added'); }, 900);
              }
            })
            .catch(function () {
              btn.removeAttribute('data-loading');
              announce('Something went wrong adding this item to your cart.');
            });
        });
      }

      function bindBuyNow(btn) {
        if (btn.dataset.prBound) return;
        btn.dataset.prBound = 'true';
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('data-loading')) return;
          btn.setAttribute('data-loading', '');
          var qty = getQty(btn.closest('.pr-qv__info') || document.body);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: btn.getAttribute('data-variant-id'), quantity: qty }] })
          })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (result) {
              if (!result.ok) {
                btn.removeAttribute('data-loading');
                announce((result.data && result.data.description) || 'Could not proceed to checkout.');
                return;
              }
              window.location.href = '/checkout';
            })
            .catch(function () {
              btn.removeAttribute('data-loading');
              announce('Something went wrong.');
            });
        });
      }

      root.querySelectorAll('[data-pr-add]').forEach(bindAddButton);

      /* Quick view modal */
      var modal = root.querySelector('[data-pr-modal]');
      var modalContent = root.querySelector('[data-pr-modal-content]');
      var lastFocused = null;

      function openModal(handle) {
        if (!modal || !modalContent) return;
        var tpl = root.querySelector('[data-pr-qv-template="' + handle + '"]');
        if (!tpl) return;
        modalContent.innerHTML = '';
        modalContent.appendChild(tpl.content.cloneNode(true));
        modalContent.querySelectorAll('[data-pr-add]').forEach(bindAddButton);
        modalContent.querySelectorAll('[data-pr-buy-now]').forEach(bindBuyNow);
        initModalGallery(modalContent);
        initQty(modalContent);
        lastFocused = document.activeElement;
        modal.hidden = false;
        var closeBtn = modal.querySelector('[data-pr-modal-close]');
        if (closeBtn) closeBtn.focus();
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocused) lastFocused.focus();
      }

      root.querySelectorAll('[data-pr-quick-view]').forEach(function (btn) {
        btn.addEventListener('click', function () { openModal(btn.getAttribute('data-handle')); });
      });
      if (modal) {
        modal.querySelectorAll('[data-pr-modal-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (evt) {
          if (evt.key === 'Escape' && !modal.hidden) closeModal();
          if (evt.key === 'Tab' && !modal.hidden) {
            var focusable = modal.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
            if (!focusable.length) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
            else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
          }
        });
      }
    }

    document.querySelectorAll('[data-pr-root]').forEach(initProductRow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshCartDrawer() {
      var wrapper = document.getElementById('shopify-section-cart-drawer-section');
      if (!wrapper) return;
      fetch(window.location.pathname + '?sections=cart-drawer-section')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data['cart-drawer-section']) wrapper.outerHTML = data['cart-drawer-section'];
          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            try { drawer.open(); } catch (e) {}
          }
        })
        .catch(function () {});
    }

    function bindAddButton(btn, announce) {
      if (btn.dataset.prrBound) return;
      btn.dataset.prrBound = 'true';
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('data-loading')) return;
        btn.setAttribute('data-loading', '');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: btn.getAttribute('data-variant-id'), quantity: 1 }] })
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            btn.removeAttribute('data-loading');
            if (!result.ok) {
              announce((result.data && result.data.description) || 'Could not add this item to your cart.');
              return;
            }
            announce('Added to cart.');
            refreshCartDrawer();
            btn.classList.add('is-added');
            window.setTimeout(function () { btn.classList.remove('is-added'); }, 900);
          })
          .catch(function () {
            btn.removeAttribute('data-loading');
            announce('Something went wrong adding this item to your cart.');
          });
      });
    }

    function setupCarousel(root) {
      var track = root.querySelector('[data-prr-track]');
      var prev = root.querySelector('[data-prr-prev]');
      var next = root.querySelector('[data-prr-next]');
      if (!track || track.dataset.prrCarouselBound || (!prev && !next)) return;
      track.dataset.prrCarouselBound = 'true';

      function cardDelta() {
        var card = track.querySelector('.prr-card');
        if (!card) return 300;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function updateArrows() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardDelta(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardDelta(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function initProductRecommendationsCard(root) {
      var status = root.querySelector('[data-prr-status]');
      function announce(msg) { if (status) status.textContent = msg; }

      root.querySelectorAll('[data-prr-add]').forEach(function (btn) { bindAddButton(btn, announce); });
      setupCarousel(root);
    }

    /* Scroll-triggered entrance for the heading+carousel wrapper — guarded
       by its own dataset flag (not reused from initProductRecommendationsCard)
       since that function reruns on every content swap from the
       MutationObserver below, but this only ever needs to wire up once. */
    function initReveal(root) {
      if (root.dataset.prrRevealInit) return;
      root.dataset.prrRevealInit = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('js-ready');

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.unobserve(root);
            }
          });
        }, { threshold: 0.15 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }
    }

    /* Shopify's native product-recommendations.js can replace this whole
       element's inner HTML client-side after fetching recommendations
       (when they weren't already rendered server-side). A MutationObserver
       re-runs setup any time that happens, instead of only once on the
       initial (possibly skeleton/empty) page load. */
    function observeRoot(root) {
      initProductRecommendationsCard(root);
      initReveal(root);
      var observer = new MutationObserver(function () {
        initProductRecommendationsCard(root);
      });
      observer.observe(root, { childList: true, subtree: true });
    }

    document.querySelectorAll('[data-prr-root]').forEach(observeRoot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductShowcase(root) {
      if (root.dataset.psInit) return;
      root.dataset.psInit = 'true';

      var track = root.querySelector('[data-ps-track]');
      var prev = root.querySelector('[data-ps-prev]');
      var next = root.querySelector('[data-ps-next]');
      var status = root.querySelector('[data-ps-status]');

      if (track && (prev || next)) {
        var cardDelta = function () {
          var card = track.querySelector('[data-ps-card]');
          if (!card) return 300;
          var style = getComputedStyle(track);
          var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
          return card.getBoundingClientRect().width + gap;
        };
        var updateArrows = function () {
          if (!prev || !next) return;
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          prev.disabled = track.scrollLeft <= 0;
          next.disabled = track.scrollLeft >= maxScroll;
        };
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardDelta(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardDelta(), behavior: 'smooth' }); });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      function announce(msg) {
        if (status) status.textContent = msg;
      }

      function refreshCartDrawer() {
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper) return Promise.resolve();
        return fetch(window.location.pathname + '?sections=cart-drawer-section')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data['cart-drawer-section']) {
              wrapper.outerHTML = data['cart-drawer-section'];
            }
          })
          .catch(function () {});
      }

      function openCartDrawer() {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (e) {}
        }
      }

      root.querySelectorAll('[data-ps-quick-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('data-ps-loading')) return;
          btn.setAttribute('data-ps-loading', '');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: btn.getAttribute('data-variant-id'), quantity: 1 }] })
          })
            .then(function (res) {
              return res.json().then(function (data) { return { ok: res.ok, data: data }; });
            })
            .then(function (result) {
              btn.removeAttribute('data-ps-loading');
              if (!result.ok) {
                announce((result.data && result.data.description) || 'Could not add this item to your cart.');
                return;
              }
              announce('Added to cart.');
              refreshCartDrawer().then(openCartDrawer);
            })
            .catch(function () {
              btn.removeAttribute('data-ps-loading');
              announce('Something went wrong adding this item to your cart.');
            });
        });
      });
    }

    document.querySelectorAll('[data-ps-root]').forEach(initProductShowcase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductVideoSection(root) {
      if (root.dataset.pvsInit) return;
      root.dataset.pvsInit = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('js-ready');

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.unobserve(root);
            }
          });
        }, { threshold: 0.2 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }
    }

    document.querySelectorAll('[data-pvs-root]').forEach(initProductVideoSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-chapters"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initScrollChapters(root) {
        if (root.dataset.scInit) return;
        root.dataset.scInit = 'true';

        var pin = root.querySelector('[data-sc-pin]');
        var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-sc-media-item]'));
        var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-sc-chapter]'));
        if (!pin || !chapters.length) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (chapters[0]) chapters[0].classList.add('is-active');
          if (mediaItems[0]) mediaItems[0].classList.add('is-active');
          chapters.forEach(function (c) { c.classList.add('is-in'); });
          return;
        }

        root.classList.add('js-ready');

        var mq = window.matchMedia('(min-width: 990px)');
        var io = null;
        var scrollHandler = null;

        function setActive(index) {
          mediaItems.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
          chapters.forEach(function (chapter, i) { chapter.classList.toggle('is-active', i === index); });
        }

        function teardown() {
          if (scrollHandler) {
            window.removeEventListener('scroll', scrollHandler, { capture: true });
            scrollHandler = null;
          }
          if (io) {
            io.disconnect();
            io = null;
          }
        }

        function setupPinned() {
          teardown();
          var ticking = false;

          function update() {
            var rect = pin.getBoundingClientRect();
            var vh = window.innerHeight;
            var total = rect.height - vh;
            var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
            var activeIndex = Math.min(chapters.length - 1, Math.floor(progress * chapters.length));
            setActive(activeIndex);
          }

          scrollHandler = function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              update();
              ticking = false;
            });
          };

          window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
          update();
        }

        function setupMobile() {
          teardown();
          setActive(0);
          io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                io.unobserve(entry.target);
              }
            });
          }, { threshold: 0.2 });
          chapters.forEach(function (chapter) { io.observe(chapter); });
        }

        function applyMode() {
          if (mq.matches) setupPinned(); else setupMobile();
        }

        applyMode();
        if (mq.addEventListener) mq.addEventListener('change', applyMode);
        else if (mq.addListener) mq.addListener(applyMode);
      }

      document.querySelectorAll('[data-sc-root]').forEach(initScrollChapters);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-text-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initScrollTextReveal(root) {
      if (root.dataset.strInit) return;
      root.dataset.strInit = 'true';

      var pin = root.querySelector('[data-str-pin]');
      var words = Array.prototype.slice.call(root.querySelectorAll('[data-str-word]'));
      var video = root.querySelector('.str-media__video');
      if (!pin || !words.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (video) { video.muted = true; video.loop = true; video.play().catch(function () {}); }
        return;
      }

      root.classList.add('js-ready');

      var mq = window.matchMedia('(min-width: 990px)');
      var scrollHandler = null;
      var videoDuration = 0;

      if (video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.loop = false;
        if (video.readyState >= 1) {
          videoDuration = video.duration || 0;
        } else {
          video.addEventListener('loadedmetadata', function () {
            videoDuration = video.duration || 0;
          });
        }
      }

      function setProgress(progress) {
        var revealCount = Math.min(words.length, Math.round(progress * words.length));
        words.forEach(function (word, i) {
          word.classList.toggle('is-revealed', i < revealCount);
        });
        if (video && videoDuration > 0) {
          video.currentTime = Math.min(videoDuration - 0.05, Math.max(0, progress * videoDuration));
        }
      }

      function teardown() {
        if (scrollHandler) {
          window.removeEventListener('scroll', scrollHandler, { capture: true });
          scrollHandler = null;
        }
      }

      function setupPinned() {
        teardown();
        if (video) { video.pause(); video.loop = false; }
        var ticking = false;

        function update() {
          var rect = pin.getBoundingClientRect();
          var vh = window.innerHeight;
          var total = rect.height - vh;
          var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
          setProgress(progress);
        }

        scrollHandler = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        };

        window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
        update();
      }

      function setupMobile() {
        teardown();
        words.forEach(function (word) { word.classList.add('is-revealed'); });
        if (video) {
          video.loop = true;
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) video.play().catch(function () {});
                else video.pause();
              });
            }, { threshold: 0.4 });
            io.observe(video);
          } else {
            video.play().catch(function () {});
          }
        }
      }

      function applyMode() {
        if (mq.matches) setupPinned(); else setupMobile();
      }

      applyMode();
      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);
    }

    document.querySelectorAll('[data-str-root]').forEach(initScrollTextReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopByVideo(root) {
      if (root.dataset.svInit) return;
      root.dataset.svInit = 'true';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sv-card]'));
      var videos = cards
        .map(function (card) { return card.querySelector('.sv-video'); })
        .filter(Boolean);

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var playing = !reduceMotion;
      var pauseBtn = root.querySelector('[data-sv-pause]');

      function syncPauseButton() {
        if (!pauseBtn) return;
        pauseBtn.setAttribute('aria-pressed', String(!playing));
        pauseBtn.setAttribute('aria-label', playing ? 'Pause videos' : 'Play videos');
      }
      syncPauseButton();

      if (videos.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && playing) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.35 });

        videos.forEach(function (video) { io.observe(video); });

        if (pauseBtn) {
          pauseBtn.addEventListener('click', function () {
            playing = !playing;
            syncPauseButton();
            videos.forEach(function (video) {
              var rect = video.getBoundingClientRect();
              var inView = rect.right > 0 && rect.left < window.innerWidth;
              if (playing && inView) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          });
        }
      } else if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', 'true');
        pauseBtn.style.display = 'none';
      }

      var track = root.querySelector('[data-sv-track]');
      var prev = root.querySelector('[data-sv-prev]');
      var next = root.querySelector('[data-sv-next]');
      if (!track) return;

      function cardDelta() {
        var card = track.querySelector('[data-sv-card]');
        if (!card) return 300;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -cardDelta(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: cardDelta(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    document.querySelectorAll('[data-sv-root]').forEach(initShopByVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-chapters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp01(n) { return Math.min(1, Math.max(0, n)); }

    function initStoryChapters(root) {
      if (root.dataset.stcInit) return;
      root.dataset.stcInit = 'true';

      var pin = root.querySelector('[data-stc-pin]');
      var sticky = root.querySelector('[data-stc-sticky]');
      var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-stc-media-item]'));
      var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-stc-chapter]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-stc-tab]'));
      var count = chapters.length;
      if (!pin || !count) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (chapters[0]) chapters[0].classList.add('is-active');
        if (mediaItems[0]) mediaItems[0].classList.add('is-active');
        return;
      }

      root.classList.add('js-ready');

      var mq = window.matchMedia('(min-width: 990px)');
      var scrollHandler = null;
      var scrollEl = document.querySelector('.page-wrapper') || window;

      function setActive(index, chapterProgress) {
        mediaItems.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
        chapters.forEach(function (chapter, i) { chapter.classList.toggle('is-active', i === index); });
        tabs.forEach(function (tab, i) {
          var fill = tab.querySelector('[data-stc-tab-fill]');
          var width = i < index ? 100 : i === index ? chapterProgress * 100 : 0;
          if (fill) fill.style.width = width + '%';
          tab.classList.toggle('is-active', i === index);
          tab.classList.toggle('is-done', i < index);
        });
      }

      function teardown() {
        if (scrollHandler) {
          window.removeEventListener('scroll', scrollHandler, { capture: true });
          scrollHandler = null;
        }
      }

      function headerOffset() {
        var v = getComputedStyle(document.body).getPropertyValue('--header-height');
        return parseFloat(v) || 0;
      }

      // The site's header shows/hides its own height as the page is
      // scrolled (e.g. an announcement bar collapsing), which would
      // otherwise make the sticky content's top offset drift mid-scroll —
      // reading as the gap above the pinned section "closing" over the
      // course of the chapters instead of staying put. Freezing it once,
      // when this section is entered, keeps every chapter consistent.
      var frozenHeaderOffset = 0;

      function setupPinned() {
        teardown();
        frozenHeaderOffset = headerOffset();
        if (sticky) sticky.style.top = frozenHeaderOffset + 'px';
        var ticking = false;

        function update() {
          var rect = pin.getBoundingClientRect();
          var vh = sticky ? sticky.getBoundingClientRect().height : window.innerHeight;
          var total = rect.height - vh;
          var progress = total > 0 ? clamp01((frozenHeaderOffset - rect.top) / total) : 0;
          var scaled = progress * count;
          var activeIndex = Math.min(count - 1, Math.floor(scaled));
          var chapterProgress = clamp01(scaled - activeIndex);
          setActive(activeIndex, chapterProgress);
        }

        scrollHandler = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        };

        window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
        update();
      }

      function setupMobile() {
        teardown();
        setActive(0, 0);
      }

      function applyMode() {
        if (mq.matches) setupPinned(); else setupMobile();
      }

      applyMode();
      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (!mq.matches) return;
          var index = parseInt(tab.getAttribute('data-index'), 10) || 0;
          var rect = pin.getBoundingClientRect();
          var vh = sticky ? sticky.getBoundingClientRect().height : window.innerHeight;
          var total = rect.height - vh;
          if (total <= 0) return;
          var currentY = scrollEl === window ? window.scrollY : scrollEl.scrollTop;
          var targetY = currentY + (rect.top - frozenHeaderOffset) + (index / count) * total + 4;
          if (scrollEl === window) window.scrollTo({ top: targetY, behavior: 'smooth' });
          else scrollEl.scrollTo({ top: targetY, behavior: 'smooth' });
        });
      });
    }

    document.querySelectorAll('[data-stc-root]').forEach(initStoryChapters);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1100;
      var start = null;

      function easeOutQuad(t) { return t * (2 - t); }

      function step(timestamp) {
        if (start === null) start = timestamp;
        var progress = Math.min(1, (timestamp - start) / duration);
        var value = Math.round(target * easeOutQuad(progress));
        el.textContent = prefix + value + suffix;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = prefix + target + suffix;
        }
      }

      window.requestAnimationFrame(step);
    }

    function initTrustBar(root) {
      if (root.dataset.tbInit) return;
      root.dataset.tbInit = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-tb-item]'));
      if (!items.length) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion) {
        root.querySelectorAll('[data-tb-count]').forEach(function (el) {
          var target = el.getAttribute('data-target');
          var prefix = el.getAttribute('data-prefix') || '';
          var suffix = el.getAttribute('data-suffix') || '';
          el.textContent = prefix + target + suffix;
        });
        return;
      }

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) { item.classList.add('is-in'); });
        root.querySelectorAll('[data-tb-count]').forEach(animateCount);
        return;
      }

      root.classList.add('js-ready');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          var counter = entry.target.querySelector('[data-tb-count]');
          if (counter) animateCount(counter);
          io.unobserve(entry.target);
        });
      }, { threshold: 0.4 });

      items.forEach(function (item) { io.observe(item); });
    }

    document.querySelectorAll('[data-tb-root]').forEach(initTrustBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-case-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUseCaseCards(root) {
      if (root.dataset.ucInit) return;
      root.dataset.ucInit = 'true';

      var track = root.querySelector('[data-uc-track]');
      var prev = root.querySelector('[data-uc-prev]');
      var next = root.querySelector('[data-uc-next]');
      if (!track) return;

      function cardDelta() {
        var card = track.querySelector('[data-uc-card]');
        if (!card) return 300;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -cardDelta(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: cardDelta(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    document.querySelectorAll('[data-uc-root]').forEach(initUseCaseCards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoShowcase(root) {
      if (root.dataset.vsInit) return;
      root.dataset.vsInit = 'true';

      var video = root.querySelector('.vs-media');
      var pauseBtn = root.querySelector('[data-vs-pause]');
      if (!video || video.tagName !== 'VIDEO') return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function syncButton(playing) {
        if (!pauseBtn) return;
        pauseBtn.setAttribute('aria-pressed', String(!playing));
        pauseBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      if (reduceMotion) {
        video.pause();
        syncButton(false);
      } else {
        syncButton(true);
      }

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            syncButton(true);
          } else {
            video.pause();
            syncButton(false);
          }
        });
      }
    }

    document.querySelectorAll('[data-vs-root]').forEach(initVideoShowcase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-zoom-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp01(v) { return Math.min(1, Math.max(0, v)); }

    function wrapLetters(heading) {
      var text = heading.textContent;
      heading.textContent = '';
      var letters = [];
      for (var i = 0; i < text.length; i++) {
        var span = document.createElement('span');
        span.className = 'vzr-letter';
        span.textContent = text[i] === ' ' ? ' ' : text[i];
        heading.appendChild(span);
        letters.push(span);
      }
      return letters;
    }

    function initVideoZoomReveal(root) {
      if (root.dataset.vzrInit) return;
      root.dataset.vzrInit = 'true';

      var pin = root.querySelector('[data-vzr-pin]');
      var mainFrame = root.querySelector('[data-vzr-main]');
      var headingWrap = root.querySelector('[data-vzr-heading-wrap]');
      var heading = root.querySelector('[data-vzr-heading]');
      var overlay = root.querySelector('[data-vzr-overlay]');
      var video = root.querySelector('.vzr-video');
      if (!pin || !mainFrame) return;

      if (video) {
        video.muted = true;
        video.play().catch(function () {});
      }

      var letters = heading ? wrapLetters(heading) : [];

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        letters.forEach(function (l) { l.classList.add('is-lit'); });
        return;
      }

      root.classList.add('js-ready');

      var mq = window.matchMedia('(min-width: 990px)');
      var scrollHandler = null;

      // Single continuous timeline across the whole pin, as fractions of
      // total scroll progress (0 to 1):
      var TEXT_REVEAL_END = 0.26; // tagline fully lit by here
      var TEXT_HOLD_END = 0.34; // brief hold at full reveal
      var TEXT_FADE_END = 0.48; // tagline fully faded out by here
      var VIDEO_GROWTH_END = 0.74; // video reaches full scale by here
      var OVERLAY_REVEAL_END = 0.88; // overlay fully visible by here
      // 0.88 -> 1.0 is the hold before the section releases and scrolls away.

      function update() {
        var rect = pin.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = rect.height - vh;
        var progress = total > 0 ? clamp01(-rect.top / total) : 0;

        if (letters.length) {
          var revealCount = Math.round(clamp01(progress / TEXT_REVEAL_END) * letters.length);
          letters.forEach(function (letter, i) {
            letter.classList.toggle('is-lit', i < revealCount);
          });
        }

        var headingOpacity = 1;
        if (progress > TEXT_HOLD_END) {
          headingOpacity = 1 - clamp01((progress - TEXT_HOLD_END) / (TEXT_FADE_END - TEXT_HOLD_END));
        }
        if (headingWrap) headingWrap.style.setProperty('--vzr-heading-opacity', headingOpacity);

        var growthProgress = clamp01(progress / VIDEO_GROWTH_END);

        // Width and height scale together at the same rate, so the frame
        // grows proportionally from small to full-screen instead of
        // stretching unevenly (which read as the video looking squished/
        // compressed early on).
        var mainMin = parseFloat(mainFrame.getAttribute('data-min-scale'));
        var mainMax = parseFloat(mainFrame.getAttribute('data-max-scale'));
        var mainScale = mainMin + (mainMax - mainMin) * growthProgress;
        mainFrame.style.setProperty('--vzr-main-scale-x', mainScale);
        mainFrame.style.setProperty('--vzr-main-scale-y', mainScale);

        if (overlay) {
          var overlayProgress = clamp01((progress - VIDEO_GROWTH_END) / (OVERLAY_REVEAL_END - VIDEO_GROWTH_END));
          overlay.style.setProperty('--vzr-overlay-opacity', overlayProgress);
        }
      }

      function teardown() {
        if (scrollHandler) {
          window.removeEventListener('scroll', scrollHandler, { capture: true });
          scrollHandler = null;
        }
      }

      function setupPinned() {
        teardown();
        var ticking = false;
        scrollHandler = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        };
        window.addEventListener('scroll', scrollHandler, { capture: true, passive: true });
        update();
      }

      function applyMode() {
        if (mq.matches) setupPinned(); else teardown();
      }

      applyMode();
      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);
    }

    document.querySelectorAll('[data-vzr-root]').forEach(initVideoZoomReveal);
  })();

  } catch(e) { console.error(e); }
})();
})();
